import React from "react";
import logoReact from '../logo.svg';
import '../styles/Home.css';

function Home() {
    return (
        <div>

            <h2>Home Page</h2>

            <hr />

            <div>
                <div style={{ width: "100%", justifySelf: "center" }}>
                    <div className="App">
                        <header className="App-header" style={{ minHeight: "50vh" }}>
                            <img src={logoReact} className="App-logo" alt="logoReact" />
                            <p>
                                Edit <code>src/App.js</code> and save to reload.
                            </p>
                            <a className="App-link" href="https://reactjs.org" target="_blank" rel="noopener noreferrer" >
                                Learn React
                            </a>
                        </header>
                    </div>
                </div>

            </div>

            <br />


            <div>
                <div style={{ width: "100%", justifySelf: "center" }}>
                    <div className="App">
                        <header className="App-header" style={{ minHeight: "50vh" }}>
                            <img src={logoReact} className="App-logo" alt="logoReact" />
                            <p>
                                Edit <code>src/App.js</code> and save to reload.
                            </p>
                            <a className="App-link" href="https://reactjs.org" target="_blank" rel="noopener noreferrer" >
                                Learn React
                            </a>
                        </header>
                    </div>
                </div>

            </div>

            <br />

        </div>
    );
}

export default Home;